import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IUserDetailsForAdmin, IUserForAdmin } from '../models/user-admin.model';
import { ApiService } from '../../shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { IUserNotes } from '../../admin/models/user.model';
import { UserProfileEdit } from '../models';
import { CreateVendor } from '../../admin/models/create-vendor';

@Injectable({
  providedIn: 'root'
})
export class UserServiceAdmin {
  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  public createUser(value: IUserForAdmin): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.apiService.post(`UserProfiles/CreateUserProfileByAdmin`, value);
  }

  public CreateVendorUsersBySuperAdmin(value: IUserForAdmin): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.apiService.post(`UserProfiles/CreateVendorUsersBySuperAdmin`, value);
  }

  public ChangePasswordBySuperAdmin(value: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.apiService.post(`UserProfiles/ChangePasswordBySuperAdmin`, value);
  }

  public createVendorAdmin(value: CreateVendor): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.apiService.post(`UserProfiles/CreateVendorAdmin`, value);
  }
  
  getUserProfile(userName:string):Observable<any> {
    return this.apiService.get(`UserProfile/GetUserDetails?userName=${userName}`);
  }
  getCompanyId(companyName:string):Observable<any> {
    return this.apiService.get(`Requirement/GetCompanyId?companyName=${companyName}`);
  }

  public activateUser(userName:string,activateByUserId:number):Observable<any>{
    return this.apiService.get(`UserProfiles/ActivateUser?userName=${userName}&activateByUserId=${activateByUserId}`);
  }
  public deactivateUser(userName:string,deactivateByUserId:number):Observable<any>{
    return this.apiService.get(`UserProfiles/DeactivateUser?userName=${userName}&deactivateByUserId=${deactivateByUserId}`);
  }
  // public getUsers(pageNo:number,pageSize:number,totalFilter:string,sortField:string,sortOrder:string): Observable<any> {
  //   return this.apiService.get(`UserProfile/GetAllUserDetails?pageNo=${pageNo}&pageSize=${pageSize}
  //   &totalFilter=${totalFilter}&sortField=${sortField}&sortOrder=${sortOrder}`);
  // }
  public getUsersTotalCount(pageNo:number,pageSize:number,totalFilter:string,sortField:string,sortOrder:string): Observable<any> {
    return this.apiService.get(`UserProfile/GetUsersTotalCount?pageNo=${pageNo}&pageSize=${pageSize}
    &totalFilter=${totalFilter}&sortField=${sortField}&sortOrder=${sortOrder}`);
  }
  public uploadUsers(fileToUpload:any) {
    let input = new FormData();
    input.append("file", fileToUpload);
    return this.apiService.post(`ApplicationUser/UploadUsers`,input);
  } 
  public uploadCompanies(value:IUserDetailsForAdmin[]):Observable<any> {
    return this.apiService.post(`UserProfile/UploadCompanies`,value);
  }
  public uploadValidUsers(value:IUserDetailsForAdmin[]):Observable<any> {
    return this.apiService.post(`UserProfile/UploadActiveUsers`,value);
  }
  
  roleMatch(allowedRoles:any):boolean {
    var isMatch= false;
    var payLoad=JSON.parse(window.atob(localStorage.getItem('token').split('.')[1]));
   // console.log(payLoad.role);
    var userRole= payLoad.role;
    allowedRoles.forEach(element => {
      if(userRole == element)
      { 
        isMatch = true;
        return false;
      }
     
    });
    return isMatch;
  }

  getUsers(): Observable<any> {
    return this.http.get('assets/user.json')
  }

  public getAllUsers(userSearchParam:IGlobalSearchParam):Observable<any> {
    return this.apiService.post(`UserProfiles/SearchUser`,userSearchParam)
  }
  public getRoles(userProfileId:number):Observable<any>{
    return this.apiService.get(`UserProfiles/UserRolesListForUserCreation?userProfileId=${userProfileId}`);
  }
  public getVendorRoles(userProfileId:number):Observable<any>{
    return this.apiService.get(`UserProfiles/GetVendorRoles?userProfileId=${userProfileId}`);
  }
  public getUserRolesEdit(userProfileId:number):Observable<any>{
    return this.apiService.get(`UserProfiles/UserRolesEdit?userProfileId=${userProfileId}`);
  }
  getRegisteredUserViewProfile(id: number): Observable<any> {
    return this.apiService.get(`userProfiles/RegisteredUserViewProfile/${id}`);
  }
  public updateUserNotes(userNotes: IUserNotes):Observable<any>{
    return this.apiService.post(`UserProfiles/UpdateUserNotes`,userNotes);
  }
  public GetUserNotes(userProfileId: number):Observable<any>{
    return this.apiService.get(`UserProfiles/GetUserNotes?userProfileId=${userProfileId}`);
  }

  getUserProfileByUserId(userProfileId:number):Observable<any> {
    return this.apiService.get(`UserProfiles/UserProfileByUserId/${userProfileId}`);
  }

  getCompanyList():Observable<any>{
    return this.apiService.get(`CompanyProfile/AllApprovedCompanyList`)
  }

  getAllUserRole():Observable<any>{
    return this.apiService.get(`CompanyProfile/AllUserRolesList`)
  }

  UpdateUserProfileByVMSAdmin(id:number, userProfile:UserProfileEdit): Observable<any>{
    return this.apiService.put(`userprofiles/UpdateUserProfileByVMSAdmin/${id}`, userProfile)
  }

  public ExportUserResult(userApprovalSearchParam:IGlobalSearchParam):Observable<any> {
    return this.http.post(`${environment.apiRoot}UserProfiles/ExportUser`, userApprovalSearchParam,
    {  
        responseType: 'blob',
        observe: 'response'
     });
  }
  public onVendorEmailCheck(vendorEmail: string): Observable<any> {
    return this.apiService.get(`Register/VendorEmailDuplicateCheck?vendorEmail=${vendorEmail}`);
  }

  public UpdateFirstViewDashBoard(UserId : number):Observable<any> {
  
    return this.apiService.get(`UserProfiles/UpdateFirstViewDashBoard/${UserId}`);
  }

  public checkPermissionToViewUser(userId:string,userProfileId:number):Observable<any>{
    return this.apiService.get(`UserProfiles/CheckPermissionToViewUser/${userId}/${userProfileId}`)
  }
  public getEntityType(entityTypeId:number):Observable<any>{
    return this.apiService.get(`Register/GetEntityType?entityTypeId=${entityTypeId}`)
  }
}
